import { Link } from "react-router-dom";
import type { Chapter } from "@/types/comic";

interface ReaderCatalogProps {
  open: boolean;
  onClose: () => void;
  comicId: string;
  comicTitle: string;
  chapters: Chapter[];
  currentId: string;
}

export default function ReaderCatalog({
  open,
  onClose,
  comicId,
  comicTitle,
  chapters,
  currentId,
}: ReaderCatalogProps) {
  return (
    <div
      className={`fixed inset-0 z-50 transition-opacity ${
        open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
      <aside
        className={`absolute top-0 right-0 h-full w-80 max-w-[85%] bg-background-50 flex flex-col transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="h-14 px-4 flex items-center justify-between border-b border-background-200 shrink-0">
          <div className="min-w-0">
            <p className="text-xs text-foreground-500">章节目录</p>
            <p className="text-sm font-medium text-foreground-950 truncate">{comicTitle}</p>
          </div>
          <button
            type="button"
            aria-label="关闭目录"
            onClick={onClose}
            className="w-9 h-9 rounded-md flex items-center justify-center text-foreground-700 hover:bg-background-100 cursor-pointer shrink-0"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-2 reader-scroll">
          {[...chapters].reverse().map((chapter) => (
            <Link
              key={chapter.id}
              to={`/read/${comicId}/${chapter.id}`}
              onClick={onClose}
              className={`block px-3 py-2.5 rounded-md text-sm mb-1 transition-colors cursor-pointer ${
                chapter.id === currentId
                  ? "bg-primary-100 text-primary-700 font-medium"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <span className="flex items-center justify-between gap-2">
                <span className="truncate">{chapter.title}</span>
                <span className="text-xs text-foreground-400 shrink-0 whitespace-nowrap">
                  {chapter.updateTime}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </aside>
    </div>
  );
}